import React, { useState, useMemo } from 'react';
import { formatText } from "../TruncateParties";
import { IoGrid, IoDocumentTextOutline } from "react-icons/io5";
import { FaTableList, FaCalendarDays, FaUserTie, FaUser, FaFileLines } from "react-icons/fa6";

export const RenderDocuments = ({ documents, variant = 'default' }) => {
  const isSCOtherDocs = variant === 'sc-other-docs';
  // Default to table view
  const [viewMode, setViewMode] = useState('table');

  // Sort documents by Date of Receiving (Latest first)
  const sortedDocuments = useMemo(() => {
    if (!documents) return [];
    
    return [...documents].sort((a, b) => {
      // Helper to parse DD-MM-YYYY to Date object
      const parseDate = (dateStr) => {
        if (!dateStr) return new Date(0); // Handle missing dates
        const [day, month, year] = dateStr.split('-');
        return new Date(`${month}/${day}/${year}`);
      };

      const dateA = parseDate(a.dateOfReceiving);
      const dateB = parseDate(b.dateOfReceiving);

      return dateB - dateA; // Descending order
    });
  }, [documents]);

  // --- Renderers ---

  const renderTableView = () => (
    <div className="table-responsive">
      <table className="documents-table">
        <thead>
          <tr>
            <th style={{ width: '80px' }} className="td-th-casedet">Sr. No.</th>
            <th className="td-th-casedet">{isSCOtherDocs ? 'Filing Date' : 'Date of Receiving'}</th>
            <th className="td-th-casedet">Filed By</th>
            <th className="td-th-casedet">{isSCOtherDocs ? 'Entered By' : 'Name of Advocate'}</th>
            <th className="td-th-casedet">{isSCOtherDocs ? 'Document Type' : 'Document Filed'}</th>
          </tr>
        </thead>
        <tbody>
          {sortedDocuments.map((doc, index) => (
            <tr key={index}>
              {/* Generated from frontend: starts at 1 and increases */}
              <td className="td-th-casedet">{index + 1}</td> 
              
              {/* <td>{doc.documentNo}</td> */}
              <td className="td-th-casedet">{doc.dateOfReceiving}</td>
              <td className="td-th-casedet">{formatText(doc.filedBy)}</td>
              <td className="td-th-casedet">{formatText(doc.advocateName)}</td>
              <td className="td-th-casedet">{formatText(doc.documentFiled)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // Updated Grid View using Cards
  const renderGridView = () => (
    <div className="documents-grid-layout">
      {sortedDocuments.map((doc, index) => (
        <div key={index} className="modern-document-card">
          {/* Header: Sr No and Date */}
          <div className="card-header-strip">
            <div className="doc-badge">
              <IoDocumentTextOutline /> Sr. No. {index + 1}
            </div>
            <div className="doc-date">
              <FaCalendarDays className="icon-cal" /> {doc.dateOfReceiving}
            </div>
          </div>

          {/* Body: All Details */}
          <div className="card-content-body">
            
            {/* Document Filed / Document Type */}
            <div className="detail-row">
              <div className="detail-label">
                <FaFileLines className="row-icon" /> {isSCOtherDocs ? 'Document Type' : 'Document Filed'}
              </div>
              <div className="detail-value highlight-text" title={doc.documentFiled}>
                {formatText(doc.documentFiled)}
              </div>
            </div>

            {/* Filed By */}
            <div className="detail-row">
              <div className="detail-label">
                <FaUser className="row-icon" /> Filed By
              </div>
              <div className="detail-value" title={doc.filedBy}>
                {formatText(doc.filedBy)}
              </div>
            </div>

            {/* Advocate Name / Entered By */}
            <div className="detail-row">
              <div className="detail-label">
                <FaUserTie className="row-icon" /> {isSCOtherDocs ? 'Entered By' : 'Advocate Name'}
              </div>
              <div className="detail-value" title={doc.advocateName}>
                {formatText(doc.advocateName)}
              </div>
            </div>

            {/* Optional Document No (if exists) */}
            {/* {doc.documentNo && (
              <div className="detail-row">
                <div className="detail-label">Doc No.</div>
                <div className="detail-value">{doc.documentNo}</div>
              </div>
            )} */}

          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="tab-content">
       {/* Header Summary and Actions Header */}
      <div className="summary header-actions-container">
        <div className="sum-amount">
          <p className="margin-zero exp-count">
             {/* Fallback to 0 if documents is undefined */}
            <strong>Total Documents - </strong> {documents ? documents.length : 0}
          </p>
        </div>

        <div className="actions-right">
          {/* View Toggles */}
          {documents && documents.length > 0 && (
            <div className="view-toggles">
              <button
                className={`toggle-btn ${viewMode === "grid" ? "active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                <IoGrid />
              </button>
              <button
                className={`toggle-btn ${viewMode === "table" ? "active" : ""}`}
                onClick={() => setViewMode("table")}
                title="Table View"
              >
                <FaTableList />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Content Body */}
      {(!documents || documents.length === 0) ? (
        <div className="no-data-container">
          <h3 className="no-data-title">No Documents Found</h3>
          <p className="no-data-message">
            {isSCOtherDocs
              ? 'No other documents have been filed for this case yet.'
              : 'No documents have been filed for this case yet.'}
          </p>
        </div>
      ) : viewMode === 'table' ? (
        renderTableView()
      ) : (
        renderGridView()
      )}
    </div>
  );
};